var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.473,
    height: 60.354,
    viewBox: "0 0 80.473 60.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "envelope",
    d: "M72.929,59.882H7.544A7.553,7.553,0,0,0,0,67.426v45.266a7.553,7.553,0,0,0,7.544,7.544H72.929a7.553,7.553,0,0,0,7.544-7.544V67.426a7.553,7.553,0,0,0-7.544-7.544Zm0,5.03a2.5,2.5,0,0,1,.964.195L40.237,94.276,6.58,65.106a2.5,2.5,0,0,1,.964-.195Zm0,50.3H7.544A2.517,2.517,0,0,1,5.029,112.7V70.42L38.589,99.5a2.518,2.518,0,0,0,3.3,0L75.444,70.42v42.273a2.517,2.517,0,0,1-2.515,2.514Z",
    transform: "translate(0 -59.882)",
    fill: "#231c5f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.bb3382e8c7e853140cc22c7760c67851.svg";
export { ForwardRef as ReactComponent };